import './Styles.css';

export interface LabelProps {
    value: string;
    required?: Boolean
}

export const Label: React.FC<LabelProps> = (props) => {

    return (
        <div className="flex flex-row gap-[3px]">
            <label className={`block text-sm font-medium text-gray-600 text-start mb-1`} htmlFor="">
                {props.value}
            </label>
            <div className={`${props.required ? "" : "hidden"} text-red-600`}>*</div>
        </div>



    )
}